import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { StatisticFilterEntity } from '../../domain/entities/StatisticFilterEntity'
import { GetServiceStatisticType } from '@/backend/market'

export class StatisticFilterModel extends StatisticFilterEntity {
  startDate!: string
  endDate!: string
  serviceId?: number
  regionId?: number
  branchId?: NumberConstructor

  constructor(dataDto: StatisticFilterEntity) {
    super()
    mapEntityProperties<StatisticFilterModel>(this, dataDto, {
      exclude: ['beginDate', 'finalDate', 'service', 'region', 'branch'],
      map: {
        startDate: dataDto.beginDate,
        endDate: dataDto.finalDate,
        serviceId: dataDto.service?.id,
        regionId: dataDto.region?.id,
        branchId: dataDto.branch?.id,
        type: dataDto.type ?? GetServiceStatisticType.DAILY
      }
    })
  }
}
